import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import { Briefcase, Share2, Monitor, Factory, RotateCw } from 'lucide-react';
import UserFirstExperienceSection from '../../Components/servicex/UserFirstExperienceSection'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import IndustriesServiceExperienceSection from '../../Components/servicex/IndustriesServiceExperienceSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import OtherExpertLedSolutionsSection from '../../Components/servicex/OtherExpertLedSolutionsSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'
import { Helmet } from "react-helmet-async";

const serviceItems = [
    {
        id: 1,
        title: "Connected Workforce",
        description: "Digitally empowered frontline workers with unified communication across shifts and sites, and mobile-first access to work orders and SOPs.",
        image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "Enterprise Applications",
        description: "ERP, EAM, and supply chain integration enabling structured procurement and order workflows with federated data governance.",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Cross-Site Teams",
        description: "End-to-end visibility across greenfield sites, remote access to change orders via MCO, and cross-plant transparency without VPN complexity.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 4,
        title: "OT & Existing Automation",
        description: "DCS, PLCs, SCADA, and supervisory control integration with mapped incident/change workflows and expanded control room scope.",
        image: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 5,
        title: "IoT & Mobile Assets",
        description: "Smart sensors and mobile equipment with real-time telemetry, condition monitoring, and connected asset identities across the entire plant.",
        image: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1000&q=80"
    }
];
const solutionsData = [
    {
        id: 1,
        title: "ServiceX",
        desc: "Deliver connected service experiences across IT, workplace, customer operations, and field teams to improve engagement and performance.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Intelligent Operations",
        desc: "Modernize enterprise operations with connected workflows, real-time visibility, and automation that improves service performance and operational efficiency.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Risk and Security",
        desc: "Strengthen governance, compliance, and resilience through integrated risk workflows that reduce exposure and protect critical business services.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        title: "IT-OT Convergence",
        desc: "We help manufacturers unify their OT environment with workflows that bridge the gap between machines, systems, and people. Standardize how operational events, incidents, and maintenance requests are captured, routed, and resolved so your production environment runs with less friction and more control.",
        products: ["OTM"]
    },
    {
        id: 2,
        title: "Commercial & After-Market Operations",
        desc: "We help manufacturing teams unify sales, subscriptions, and after-market services on a single platform. Automate order-to-cash workflows, manage exceptions without manual effort, and empower your support teams to handle after-market activities with speed and precision.",
        products: ["MCO"]
    },
    {
        id: 3,
        title: "OT Security & Compliance",
        desc: "We help you protect your operational environment from the inside out. Deliver continuous monitoring, threat detection, and policy enforcement across your industrial control systems maintaining visibility and control without compromising uptime.",
        products: ["OTVR"]
    },
    {
        id: 4,
        title: "Asset Intelligence & Monitoring",
        desc: "We help your teams move beyond reactive maintenance with real-time telemetry, condition-based alerts, and predictive insights across every critical asset, so action happens before failures do, not after.",
        products: ["OTAM"]
    }
];

const industryTabs = [
    {
        id: "manufacturing",
        label: "Manufacturing",
        title: "Manufacturing",
        desc: "We help manufacturers drive digital innovation across production, maintenance, and supply chain operations through intelligent automation and AI-powered insights.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "bfsi",
        label: "BFSI",
        title: "BFSI",
        desc: "Our innovation frameworks enable financial institutions to modernize operations, enhance customer experiences, and maintain compliance in highly regulated environments.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "retail",
        label: "Retail",
        title: "Retail",
        desc: "Retail organizations leverage our AI-driven innovation capabilities to improve customer engagement, optimize operations, and deliver seamless omnichannel experiences.",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "telecom",
        label: "Telecommunication",
        title: "Telecommunication",
        desc: "We help telecom providers innovate across customer service, network operations, and field service through intelligent workflows and scalable digital platforms.",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "Industry 4.0 & 5.0 Readiness",
        desc: "Future-proof your smart manufacturing architecture with scalable, connected, and human-centric industrial workflows."
    },
    {
        id: 2,
        title: "Outcome-Driven Accelerators",
        desc: "Deploy pre-built operational frameworks designed to shorten time-to-value across shop-floor and back-office functions."
    },
    {
        id: 3,
        title: "Proven Manufacturing Track Record",
        desc: "Decades of collective experience delivering resilient operational technology and workflow modernization for global plants."
    },
    {
        id: 4,
        title: "Technical Excellence via Strategic Partners",
        desc: "Leverage certified platform engineering and deep ecosystem integrations tailored to mission-critical industrial architectures."
    },
    {
        id: 5,
        title: "Manufacturing-First Thinking",
        desc: "Solutions structured around real factory operating environments, asset lifecycles, and frontline workforce needs."
    },
    {
        id: 6,
        title: "Minimal Product Disruption",
        desc: "Implement modern digital controls and automated governance without interrupting live production lines or operational uptime."
    }
];


const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];

const faqData = [
    {
        id: 1,
        question: "What does enterprise innovation mean in today's business context?",
        answer: "Enterprise innovation means rapidly translating emerging technologies—like generative AI, low-code platforms, and automated workflows—into scalable operational capabilities that deliver measurable business value."
    },
    {
        id: 2,
        question: "How is Aelum's innovation approach different from traditional digital transformation?",
        answer: "Instead of long, rigid transformation cycles, we focus on outcome-driven, modular innovation. We combine design thinking, rapid low-code prototyping, and embedded AI directly inside existing workflows for faster time-to-value."
    },
    {
        id: 3,
        question: "How do you help enterprises move from AI experimentation to execution?",
        answer: "We bridge the gap between proof-of-concept and production by integrating robust AI models and Now Assist capabilities directly into day-to-day enterprise platforms, complete with enterprise-grade governance and security."
    },
    {
        id: 4,
        question: "What types of business problems can innovation services solve?",
        answer: "They eliminate operational bottlenecks, modernize legacy multi-system processes, overcome manual workflow delays, enhance customer/employee digital journeys, and enable agile application delivery."
    },
    {
        id: 5,
        question: "How does AI-driven innovation improve business outcomes?",
        answer: "It dramatically reduces processing times, eliminates repetitive manual errors, surfaces predictive operational insights, and allows workforce bandwidth to shift toward high-impact strategic tasks."
    },
    {
        id: 6,
        question: "Which industries benefit most from AI-driven innovation?",
        answer: "Data-intensive and service-critical industries such as BFSI, Manufacturing, Healthcare, Retail, and Telecommunications see the highest impact through automated decision-making and streamlined end-to-end operations."
    }
];


function IndustrialEdge() {
    return (
        <div>
            <Helmet>
    {/* Primary SEO */}
    <title>
        Industrial Edge & Smart Manufacturing Solutions | Mobikode
    </title>

    <meta
        name="description"
        content="Transform manufacturing operations with Mobikode Industrial Edge solutions. Connect IT and OT, strengthen OT security, improve asset intelligence, reduce downtime, and accelerate Industry 4.0 and 5.0 transformation."
    />

    <meta
        name="keywords"
        content="Industrial Edge, Industrial Edge Solutions, Smart Manufacturing Solutions, Manufacturing Enterprise AI & ServiceNow Consulting Company, IT OT Convergence, IT OT Integration, OT Security, OT Cybersecurity, Asset Intelligence, Asset Monitoring, Predictive Maintenance, Industrial IoT, IIoT Solutions, Industry 4.0, Industry 5.0, Smart Factory Solutions, Manufacturing Automation, ServiceNow OTM, ServiceNow Manufacturing, Operational Technology, Industrial Operations, Manufacturing Technology Solutions, Digital Manufacturing, Connected Factory"
    />

    {/* Robots */}
    <meta
        name="robots"
        content="index, follow, max-image-preview:large"
    />

    <meta
        name="googlebot"
        content="index, follow"
    />

    {/* Canonical */}
    <link
        rel="canonical"
        href="https://www.mobikode.com/industrial-edge"
    />

    {/* Open Graph */}
    <meta
        property="og:title"
        content="Industrial Edge & Smart Manufacturing Solutions | Mobikode"
    />

    <meta
        property="og:description"
        content="Connect shop floors, IT, OT, assets, and operations with Mobikode Industrial Edge solutions for smarter, more secure, and connected manufacturing."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/industrial-edge"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:site_name"
        content="Mobikode"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/glodesk/bg2.png"
    />

    <meta
        property="og:image:alt"
        content="Mobikode Industrial Edge and Smart Manufacturing Solutions"
    />

    {/* Twitter */}
    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Industrial Edge & Smart Manufacturing Solutions | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Modernize manufacturing with IT-OT convergence, OT security, asset intelligence, predictive operations, and connected industrial workflows."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/glodesk/bg2.png"
    />

    {/* Structured Data */}
    <script type="application/ld+json">
        {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Industrial Edge & Smart Manufacturing Solutions",
            "serviceType": "Industrial Edge Solutions",
            "description":
                "Mobikode provides Industrial Edge solutions for manufacturers to connect IT and OT environments, improve asset intelligence, strengthen OT security, enable predictive operations, and accelerate Industry 4.0 and Industry 5.0 transformation.",
            "provider": {
                "@type": "Organization",
                "name": "Mobikode",
                "url": "https://www.mobikode.com/"
            },
            "areaServed": {
                "@type": "Place",
                "name": "Worldwide"
            },
            "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Industrial Edge Offerings",
                "itemListElement": [
                    {
                        "@type": "OfferCatalog",
                        "name": "IT-OT Convergence"
                    },
                    {
                        "@type": "OfferCatalog",
                        "name": "Commercial & After-Market Operations"
                    },
                    {
                        "@type": "OfferCatalog",
                        "name": "OT Security & Compliance"
                    },
                    {
                        "@type": "OfferCatalog",
                        "name": "Asset Intelligence & Monitoring"
                    }
                ]
            },
            "url": "https://www.mobikode.com/industrial-edge"
        })}
    </script>
</Helmet>
            <WhoHero
                title="For Smart Factory"
                text="Connects your shop floor, operations, and supply chain into one intelligent foundation"
                imgData="/assets/glodesk/bg2.png"
            />
            <UserFirstExperienceSection title="Built for Real Manufacturing" description="Unify IT, OT, procurement, asset intelligence, and MCO capabilities across PLCs, SCADA, OPC servers, and MES environments through a connected Industrial Edge operating model. Improve OEE, reduce downtime with predictive operations, and strengthen compliance and OT security through real-time operational intelligence. Gain end-to-end visibility across assets, production lines, and facilities while accelerating Industry 4.0 and 5.0 transformation initiatives." />
            <ServiceX360ViewSection title="The Outcomes That Move the Needle" description="Mobikode helps organizations build a structured innovation approach that connects technology, workflows, and business goals. This allows teams to experiment, develop new capabilities, and scale them across the enterprise. With our approach, organizations can" serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our Full Suite of Industrial Edge Offerings" description="With Industrial Edge, Aelum helps manufacturers activate outcome-driven workflows across every layer of operations." />
            {/* <IndustriesServiceExperienceSection title="Accelerating Innovation Across Industries" industryTabs={industryTabs} /> */}
            <WhatSetsApartSection title="Mobikode for Industrial Edge" description="" apartData={apartData} />
            {/* <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} /> */}
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            {/* <FAQSection faqData={faqData} /> */}
        </div>
    )
}

export default IndustrialEdge
